import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
Vue.use(Vuex);
const key = process.env.VUE_APP_KEY;

import { EncryptStorage } from "encrypt-storage";
export const encryptStorage = new EncryptStorage(key, {
  prefix: "@supplierrs",
  encAlgorithm: "Rabbit",
});
export default new Vuex.Store({
  state: {
    connection_snack: false,
    drawer: true,
    def_path: "https://seder.rsst.app",
    //def_path: "http://127.0.0.1:8000",
    fcmToken: encryptStorage.getItem("fcmToken", key) || null,
    token: encryptStorage.getItem("token_suppliers_user", key) || null,
    suppliers_user: encryptStorage.getItem("suppliers_user", key) || {
      isSupp: true,
    },
    break_point: 0,
    langs: [],
    userPermissions: [],
    supplierPermissions: [],

    business_types: [],
    prices: [],
    def_locale: "HE",
    products: {
      done: false,
      data: [],
    },
    cities: {
      done: false,
      data: [],
    },
    selectCities: [],
    deliveries: {
      done: false,
      data: [],
    },
    supplier_cities: {
      done: false,
      data: [],
    },
    prices_cities: {
      done: false,
      data: [],
    },
    brands: {
      done: false,
      data: [],
    },
    categories: {
      done: false,
      data: [],
    },
    banners: {
      done: false,
      data: [],
    },
    notificationsNumber: 0,
  },
  getters: {
    loggedin(state) {
      return state.token != null;
    },
    isSupp(state) {
      return state.suppliers_user.isSupp;
    },
    langs(stat) {
      return stat.langs;
    },
    default_lang(state) {
      if (state.langs.done) {
        return state.langs.find((l) => l.is_default);
      }
      return {
        locale: "AR",
      };
    },
    items: (stat) => (items) => {
      return stat[items];
    },
    getLocaleCookie() {
      let cookieArr = document.cookie.split(";");

      // Loop through the array elements
      for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
          and compare it with the given string */
        if ("locale" == cookiePair[0].trim()) {
          // Decode the cookie value and return
          return decodeURIComponent(cookiePair[1]);
        }
      }

      // Return null if not found
      return null;
    },
    fcmToken(state) {
      return state.fcmToken;
    },
    notificationsNumber(state) {
      return state.notificationsNumber;
    },
  },
  mutations: {
    login(state, token) {
      state.token = token;
    },
    user(state, user) {
      state.suppliers_user = user;
    },
    clearData(state) {
      state.token = null;
      encryptStorage.clear();
      state.products = { done: false, data: [] };
      state.cities = { done: false, data: [] };
      state.selectCities = [];
      state.deliveries = { done: false, data: [] };
      state.supplier_cities = { done: false, data: [] };
      state.prices_cities = { done: false, data: [] };
      state.brands = { done: false, data: [] };
      state.categories = { done: false, data: [] };
      state.banners = { done: false, data: [] };
      state.langs = [];
    },
    business_types(state, items) {
      state.business_types = items;
    },
    store_items(state, items) {
      state[items.items].data = items.data;
      state[items.items].done = true;
    },
    update_props(state, obj) {
      state[obj.items].data[obj.index][obj.prop] = obj.val;
    },
    saveFcmToken(state, token) {
      encryptStorage.setItem("fcmToken", token, key);
    },
    increaseNotification(state) {
      return state.notificationsNumber++;
    },
    resetNotification(state) {
      return (state.notificationsNumber = 0);
    },
  },
  actions: {
    login(context, cred) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("phone_number", cred.phone_number);
        var config = {
          method: "post",
          url: "suppliers/login",
          headers: {
            Accept: "application/json",
          },
          data: formData,
        };
        axios(config)
          .then((res) => {
            const token = res.data.data.token;
            encryptStorage.setItem("token_suppliers_user", token, key);
            encryptStorage.setItem("suppliers_user", res.data.data, key);
            context.commit("login", token);
            context.commit("user", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    public__request(context, cred) {
      return new Promise((resolve, reject) => {
        let config = {
          method: cred.config.method,
          url: cred.config.url,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${context.state.token}`,
          },
          data: cred.data || [],
        };
        axios(config)
          .then((res) => {
            resolve(res);
            context.state.connection_snack = false;
            if (cred.get) {
              context.commit("public__request", {
                data: res.data,
                name: cred.get,
              });
            }
          })
          .catch((err) => {
            if (!err.response) {
              context.state.connection_snack = true;
            } else {
              reject(err);
            }
            if (err.response.status == 401) {
              context.dispatch("logout");
            }
          });
      });
    },
    get_langs(context, cred) {
      context
        .dispatch("public__request", {
          config: {
            url: "admin/languages",
            method: "get",
          },
        })
        .then((res) => {
          context.state.langs = Object.assign([], res.data.data);
        });
    },
    async get_requirements(context, cred) {
      await context
        .dispatch("public__request", {
          config: {
            // url: "http://127.0.0.1:8000/api/v1/supplier/requirements",
            url: "https://seder.rsst.app/api/v1/supplier/requirements",
            method: "get",
          },
        })
        .then((res) => {
          context.state.langs = Object.assign([], res.data.data.langs);
          context.state.selectCities = Object.assign(
            [],
            res.data.data.selectCities
          );

          context.state.userPermissions = res.data.data.userPermissions;
          context.state.supplierPermissions = res.data.data.supplierPermissions;
          context.state.def_locale =
            context.getters.getLocaleCookie ||
            context.getters.default_lang.locale;
        });
    },
    logout(context) {
      if (context.getters.loggedin) {
        if (context.getters.isSupp) {
          context.dispatch("public__request", {
            config: {
              url: "supplier/notification",
              method: "delete",
            },
          });
          setTimeout(() => {
            context.commit("clearData");
            window.location.reload();
          });
        } else {
          context.commit("clearData");
          window.location.reload();
        }
      }
    },
  },
  modules: {},
});
